import { RG_TYPE } from "@project-rouge/rg-core";
import { getRgObjectsOfType, createPodiumEmptySpaces } from "@project-rouge/rg-three";
import { getActiveZones } from "./index186.js";
const pipeAddPodiumEmptySpaces = ([parent, { aggProps, buildingIds }]) => {
  const zones = getActiveZones(parent, aggProps);
  for (const zone of zones) {
    const aggZoneProps = aggProps.zones[zone.uuid];
    if (aggZoneProps.podium) {
      const buildings = getRgObjectsOfType(zone, RG_TYPE.Building);
      for (const building of buildings) {
        if (buildingIds && !buildingIds.includes(building.uuid))
          continue;
        createPodiumEmptySpaces({
          building,
          podiumStart: aggZoneProps.podium.start,
          podiumCount: aggZoneProps.podium.count,
          podiumHeight: aggZoneProps.podium.height
        });
      }
    }
  }
  return [parent, void 0];
};
export {
  pipeAddPodiumEmptySpaces
};
//# sourceMappingURL=index93.js.map
